// extracted by mini-css-extract-plugin
export default {"cta":"uH-z","disabled":"vH-z"};